module.exports = __webpack_public_path__ + "img/Sport.d28a16b2.jpg";